module.exports = __webpack_public_path__ + "img/火龙果5.799983cb.png";